const EVENT = "ph-prefill";

export function goToForm(prefill = {}) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: prefill }));
  const el = document.getElementById("contatti");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  if (window.location.hash !== "#contatti") window.history.replaceState(null, "", "#contatti");
}

export function onPrefill(handler) {
  const fn = (e) => handler(e.detail || {});
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}

export function scrollToHash(href) {
  const id = href.replace("#", "");
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.replaceState(null, "", href);
  }
}
